<template lang="pug">
  .pause
    .pause__content
      .pause__title Пауза
      p.pause__text Нажмите пробел, чтобы продолжить
      p.pause__text.pause__text_xs Нажмите, чтобы продолжить
      button.pause__button(@click="$emit('continue')") Продолжить
</template>

<script>
export default {
  name: 'Start',
};
</script>

<style lang="scss">
  .pause {
    @include game-window;
    &__text {
      @media (-moz-touch-enabled: 1),
        (pointer: coarse) {
        display: none;
      }
      &_xs {
        display: none;
        @media (-moz-touch-enabled: 1),
          (pointer: coarse) {
          display: block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Pause.vue